import Vue from 'vue';
import App from '@/App.vue';
//阻止显示生产模式的消息
Vue.config.productionTip = false;
/* 引入路由 */
import router from '@router';
/* 引入store */
import store from '@store';
/* 存储类工具包 */
import localStorage from '@utils/localstorage';

/* 移动端调试面板*/
import vconsole from 'vconsole';
if (process.env.VUE_APP_BUILD_VCONSOLE === '1') {
  new vconsole()
}
/* 全局引入Vant */
import Vant from 'vant';
import 'vant/lib/index.css';
/* 二维码生成组件 */
import VueQr from 'vue-qr';
/* 轻提示 */
import { Toast } from 'vant';
/* Vue图片浏览组件v-viewer，支持旋转、缩放、翻转等操作 */
import Viewer from 'v-viewer';
import '@/utils/sysUtil'
import 'viewerjs/dist/viewer.css';

Viewer.setDefaults({
  inline: false, //启用 inline 模式
  button: false, //显示右上角关闭按钮 
  navbar: false, //显示缩略图导航
  title: false, //显示当前图片的标题
  toolbar: false, //显示工具栏
  tooltip: true, //显示缩放百分比
  movable: false, //图片是否可移动
  zoomable: true, //图片是否可缩放
  rotatable: false, //图片是否可旋转
  scalable: false, //图片是否可翻转
  transition: true, //使用 CSS3 过度
  fullscreen: false, //播放时是否全屏
  keyboard: false, //是否支持键盘
});
Vue.use(localStorage);
Vue.use(Vant);
Vue.use(Viewer);
Vue.use(VueQr);
Vue.use(Toast);
Toast.setDefaultOptions({ duration: 8000 }); // 设置全局提示停留时间
//====================自定义过滤器
/* 引入金额格式化插件 */
import {
  moneyFomart
} from '@utils/common';
Vue.filter("moneyFomart", moneyFomart)
/* 引入选择就诊人组件 */
import selectPatient from '@components/selectPatient';
Vue.component('select-patient', selectPatient)
//axios并没有install 方法，所以是不能直接使用vue.use()方法，不支持全局使用（即this.axios调用）；现结合vue-axios可全局调用
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios);
//自定义指令;照片加载处理
import loadImg from '@utils/loadImg';
Vue.directive('real-img', loadImg)

//微信授权插件
import wechatAuth from '@plugins/wechat-auth'
Vue.use(wechatAuth, {
    router: router,
    appid: process.env.VUE_APP_APPID,
    responseType: 'code',
    scope: 'snsapi_userinfo',
    getCodeCallback(next, code) {
      //1.调用mobilehealth-wx中getOpenId方法，通过前端传入的code来获取用户信息
      axios.get(process.env.VUE_APP_GET_USERINFO_URL, {
        params: {
          code: code,
          state: ''
        }
      }).then(function(res) {
        if (res.data.success) {
          // 返回，微信用户信息相关信息
          //2.调用mobilehealth-wechat中getToken方法，通过前端传入openid获取移动端getToken
          axios.get(process.env.VUE_APP_PANKU_SERVICE + "/patient/getToken", {
            params: {
              openId: res.data.result
            }
          }).then(function(res1) {
            if (res1.data.success) {
              //返回token，存储到localStorage中
              sessionStorage.setItem('USER_TOKEN', res1.data.result)
              //localStorage.save('USER_TOKEN', res1.data.result)
              // next(location.pathname.substring(5), 'nextPage') // 返回URL的域名（域名IP）后的部分
              //2023-10-13支持拼接参数进行授权之后有参数
              let winUrl=window.location.href;
              next(winUrl.substring(winUrl.indexOf('panku-gzh-wxui')+14), 'nextPage')
            } else {
              //获取openid换取token失败
              next('/CommonError/' + res1.data.message);
            }
          })
              .catch(() => {
                //获取openid换取token失败
                next('/WxAuthErr')
              })
        } else {
          next('/WxAuthErr')
        }
      }).catch(() => {
        //授权失败跳转到授权失败页面
        next('/WxAuthErr')
      });
    }
  })
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
